import React, { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

export const EmailPlanContext = createContext({
    currentEmailPlan: 'three',
    setEmailPlan: () => {}
});

export function EmailPlanProvider({ children }) {
    const [currentEmailPlan, setEmailPlan] = useState('three');

    const value = useMemo(
        () => ({
            currentEmailPlan,
            setEmailPlan
        }),
        [currentEmailPlan]
    );

    return <EmailPlanContext.Provider value={value}>{children}</EmailPlanContext.Provider>;
}

EmailPlanProvider.propTypes = {
    children: PropTypes.node.isRequired
};
